/**
 * Legacy module — preserved as an empty AngularJS module so existing
 * dependencies (`acme.common.service.calendar`) keep resolving.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/calendar/calendar.service.ts
 *
 * It is registered with AngularJS in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * via downgradeInjectable, so any `$inject = ['CalendarService']` resolves
 * to the Angular 18 class.
 */
angular.module('acme.common.service.calendar', [
  'acme.common.service.helpers',
  'acme.common.service.userPreferences'
]);
